import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import favicon from "../../images/favicon.jpg"

const Seo = ({ page, data, defaultUrl }) => {
  const data2 = useStaticQuery(query)

  return (
    <>
      {page === "blogIndexPage" ? (
        <Helmet title="blog">
          <meta
            name="google-site-verification"
            content="SL5yeBdAEuNVqE3cn3ytu6vKeBWG-0S7nB-TeGt6SSs"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Regular.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Medium.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-MediumItalic.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Semibold.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Bold.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />

          <link rel="icon" href={favicon} />
          <html lang="en" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
          />
          <meta property="og:title" content="Blog" />
        </Helmet>
      ) : (
        <Helmet title={data.title}>
          <meta
            name="google-site-verification"
            content="SL5yeBdAEuNVqE3cn3ytu6vKeBWG-0S7nB-TeGt6SSs"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Regular.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Medium.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-MediumItalic.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Semibold.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link
            rel="preload"
            href="/fonts/Graphik-Bold.woff2"
            as="font"
            crossorigin="anonymous"
            type="font/woff2"
          />
          <link rel="icon" href={favicon} />
          <html lang="en" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
          />
          {data.title && <meta property="og:title" content={data.title} />}
          {data.metaDesc && <meta name="description" content={data.metaDesc} />}
          {data.opengraphImage !== null && (
            <meta
              name="image"
              content={
                data2.site.siteMetadata.siteUrl +
                data.opengraphImage.localFile.publicURL
              }
            />
          )}
          {data.opengraphUrl && (
            <meta property="og:url" content={data.opengraphUrl} />
          )}
          {data.opengraphSiteName && (
            <meta property="og:site_name" content={data.opengraphSiteName} />
          )}

          {page === "blogPost" ? (
            <meta property="og:type" content="article" />
          ) : null}
          {data.opengraphTitle && (
            <meta property="og:title" content={data.opengraphTitle} />
          )}
          {data.opengraphDescription && (
            <meta
              property="og:description"
              content={data.opengraphDescription}
            />
          )}
          {data.opengraphImage !== null && (
            <meta
              property="og:image"
              content={
                data2.site.siteMetadata.siteUrl +
                data.opengraphImage.localFile.publicURL
              }
            />
          )}

          {data.canonical !== "" ? (
            <link rel="canonical" href={data.canonical} />
          ) : (
            <link rel="canonical" href={defaultUrl} />
          )}

          <meta name="twitter:card" content="summary_large_image" />

          {/* Twitter */}
          {data.twitterTitle && (
            <meta name="twitter:title" content={data.twitterTitle} />
          )}
          {data.twitterDescription && (
            <meta
              name="twitter:description"
              content={data.twitterDescription}
            />
          )}
          {data.twitterImage !== null && (
            <meta
              name="twitter:image"
              content={
                data2.site.siteMetadata.siteUrl +
                data.twitterImage.localFile.publicURL
              }
            />
          )}
        </Helmet>
      )}
    </>
  )
}
export default Seo

const query = graphql`
  query SiteUrl {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`
